import CancelIconWebp from './images/cancel.webp';

export const images = {
  CancelIconWebp,
};
